/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignaturePlacement
 */
export interface SignaturePlacement {
    /**
     * Signature image as data URL (e.g., "data:image/png;base64,iVBORw0KGgo..." or "data:image/jpeg;base64,/9j/4AAQ...")
     * @type {string}
     * @memberof SignaturePlacement
     */
    image: string;
    /**
     * Page number (0-based)
     * @type {number}
     * @memberof SignaturePlacement
     */
    page: number;
    /**
     * X position as percentage of page width
     * @type {number}
     * @memberof SignaturePlacement
     */
    x: number;
    /**
     * Y position as percentage of page height
     * @type {number}
     * @memberof SignaturePlacement
     */
    y: number;
    /**
     * Width as percentage of page width
     * @type {number}
     * @memberof SignaturePlacement
     */
    width: number;
    /**
     * Height as percentage of page height
     * @type {number}
     * @memberof SignaturePlacement
     */
    height: number;
}

/**
 * Check if a given object implements the SignaturePlacement interface.
 */
export function instanceOfSignaturePlacement(value: object): value is SignaturePlacement {
    if (!('image' in value) || value['image'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    return true;
}

export function SignaturePlacementFromJSON(json: any): SignaturePlacement {
    return SignaturePlacementFromJSONTyped(json, false);
}

export function SignaturePlacementFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignaturePlacement {
    if (json == null) {
        return json;
    }
    return {
        
        'image': json['image'],
        'page': json['page'],
        'x': json['x'],
        'y': json['y'],
        'width': json['width'],
        'height': json['height'],
    };
}

export function SignaturePlacementToJSON(json: any): SignaturePlacement {
    return SignaturePlacementToJSONTyped(json, false);
}

export function SignaturePlacementToJSONTyped(value?: SignaturePlacement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'image': value['image'],
        'page': value['page'],
        'x': value['x'],
        'y': value['y'],
        'width': value['width'],
        'height': value['height'],
    };
}

